import { useEffect, useState } from "react";

function useIsTouchscreen() {
    const [isTouchscreen, setIsTouchscreen] = useState(false);
  
    useEffect(() => {
      const checkTouchScreen = () => {
        setIsTouchscreen(
          'ontouchstart' in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0
        );
      };
      
      checkTouchScreen();
    }, []);
  
    return isTouchscreen;
  }
  
  export default useIsTouchscreen;